import {useState} from "react";
import './Login.scss';
import TextLogo from "../../components/TextLogo/TextLogo";
import {login} from "../../services/loginService";
import {toast} from "react-hot-toast";
import {getUserByToken, setToken} from "../../services/authService";
import {useNavigate} from "react-router-dom";
import ModalAlterarSenha from "../../components/ModalAlterarSenha/ModalAlterarSenha";
import jwt_decode from "jwt-decode";

export default function Login() {
    const navigate = useNavigate()

    const [email, setEmail] = useState<string | undefined>(undefined)
    const [senha, setSenha] = useState<string | undefined>(undefined)

    const [loading, setLoading] = useState<boolean>(false)
    const [showModalSenha, setShowModalSenha] = useState<boolean>(false)
    const [pendingToken, setPendingToken] = useState<string | null>(null)

    async function handleSubmit(e: any) {
        e.preventDefault()
        let loginDTO = {
            "usuario": email,
            "senha": senha
        }
        setLoading(true)
        await login(loginDTO)
            .then(async (response) => {
                if (response.payload.senhaPadrao) {
                    setPendingToken(response.payload.token)
                    setShowModalSenha(true)
                } else {
                    setToken(response.payload.token)
                    let usuario = getUserByToken()
                    toast.success(`Olá ${usuario.nome.split(" ")[0]}`, {
                        icon: '👋',
                        duration: 4000
                    })
                    navigate("/")
                }
            })
            .catch((e) => {
                console.log(e)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    function handleSenhaAlterada() {
        const decoded: any = jwt_decode(pendingToken!)
        const usuario = decoded.usuario
        toast.success(`Olá ${usuario.nome.split(" ")[0]}`, {
            icon: '👋',
            duration: 4000
        })
        setPendingToken(null)
        setShowModalSenha(false)
        navigate("/")
    }

    return (
        <div className={"login vh-100 d-flex align-items-center"}>
            <div className={"login-container mx-auto"}>
                <div className={"logo d-flex justify-content-center"}>
                    <TextLogo />
                </div>
                <div className={"content bg-white shadow-sm rounded-2 pt-4 pb-3 px-4"}>
                    <form onSubmit={(e) => handleSubmit(e)}>
                        <div className="mb-2">
                            <label htmlFor="titulo" className="form-label">Usuario</label>
                            <input type="text" className="form-control" id="titulo" onChange={(e) => setEmail(e.target.value)} />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="descricao" className="form-label">Senha</label>
                            <input type="password" className="form-control" id="descricao" aria-describedby="descricaoHelp" onChange={(e) => setSenha(e.target.value)}/>
                            <div id="descricaoHelp" className="form-text">
                            </div>
                        </div>
                        <div className={"d-flex justify-content-end"}>
                            <button type="submit" disabled={loading} className="btn btn-primary">
                                {loading && (
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                )}
                                <span>Entrar</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            {showModalSenha && pendingToken && (
                <ModalAlterarSenha onSenhaAlterada={handleSenhaAlterada} token={pendingToken} />
            )}
        </div>
    )
}